import React from "react";
import SharedPasswordLinkResentContent from "../components/password_link_resent_content";

export default function PasswordLinkResentContent() {
  return (
    <SharedPasswordLinkResentContent
      title="Password Reset Link Resent"
      description="An email containing your new password reset link will be sent to your email address."
    />
  );
}
